export function sendGAClickEvent(label) {
  if (typeof gtag !== 'undefined') {
    gtag('event', label, {'event_category': 'button_click', 'event_label': label})
  }
}
